import { Component, signal } from '@angular/core';
import { slideInOutAnimation } from '../slide-in-out-animation';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
    animations: [slideInOutAnimation],
    selector: 'tt-top250map-legend',
     imports: [
    MatExpansionModule,
    TranslateModule
  ],
 templateUrl: './top250map-legend.component.html',
    styleUrls: ['../legend.component.scss'],
    standalone: true
})
export class Top250mapLegendComponent  {
  active: boolean;
  disableAnimation = signal(true);  
  constructor(public translateService: TranslateService) { }
   //workaround to avoid flickering of opened panel on first opening
    ngAfterViewInit(): void {
      this.disableAnimation.set(false);
    }
}